import { DELAYED_DELIVERY_SKU } from '../constants/constants'
import type * as DynamakerContract from '../integration/DynamakerContract'

const isDelayedDeliveryArticle = (article: DynamakerContract.ConfigurationSectionArticle): boolean =>
  article.erpItemNumber === DELAYED_DELIVERY_SKU

export const hasDelayedDelivery = (bom: DynamakerContract.BOM): boolean =>
  bom.some((section) => section.articles.some(isDelayedDeliveryArticle))

/*
  DynaMaker knows nothing about the delayed delivery article, so the customer's choice is applied to its bom here.

  Any occurrence already in the bom, e.g. from a preset saved with it, is removed first, so the choice alone decides
  whether the article is there and it can never be counted twice.

  The article gets a section of its own, last and with a position no other section uses, so no section can refer
  to it as its owner. ownerPosition points at the building kit, the way DynaMaker ties ITEMS and OPTIONAL to it. It
  is left undefined in the unlikely case that the bom has no building kit.
*/
export const applyDelayedDelivery = (bom: DynamakerContract.BOM, isSelected: boolean): DynamakerContract.BOM => {
  const bomWithoutArticle = bom.flatMap((section) => {
    if (!section.articles.some(isDelayedDeliveryArticle)) return [section]

    const articles = section.articles.filter((article) => !isDelayedDeliveryArticle(article))
    return articles.length ? [{ ...section, articles }] : []
  })

  if (!isSelected) return bomWithoutArticle

  const buildingKit = bomWithoutArticle.find((section) => section.type === 'BUILDING_KIT')

  return [
    ...bomWithoutArticle,
    {
      type: 'OPTIONAL',
      position: Math.max(-1, ...bomWithoutArticle.map((section) => section.position)) + 1,
      ownerPosition: buildingKit?.position,
      articles: [{ erpItemNumber: DELAYED_DELIVERY_SKU, quantity: 1 }],
    },
  ]
}
